/* Weaving Creation — generic options builder for configurable products
   (tzitzit, kippot, bags, wall hangings, vests). Collects button-group choices
   + conditional text fields into Shopify line-item properties. No priced add-ons. */
(function () {
  "use strict";
  var root = document.querySelector("[data-optbuilder]");
  var form = document.querySelector("[data-product-form]");
  if (!root || !form) return;

  function groups() { return [].slice.call(root.querySelectorAll("[data-group]")); }
  function activeVal(g) { var b = g.querySelector(".option__btn.is-selected"); return b ? b.getAttribute("data-val") : null; }

  var texts = [].slice.call(root.querySelectorAll("[data-prop-text]"));

  // ---- Priced surcharge add-ons (added as separate cart lines) ----
  function money(p) { return "$" + (Math.round(p * 100) / 100).toFixed(2); }
  function surchargeEls() { return [].slice.call(root.querySelectorAll("[data-surcharge]")); }
  function activeSurcharges() {
    return surchargeEls().filter(function (s) {
      var g = root.querySelector('[data-group="' + s.getAttribute("data-surcharge-group") + '"]');
      if (!g) return false;
      var v = activeVal(g);
      var when = s.getAttribute("data-surcharge-when");
      var unless = s.getAttribute("data-surcharge-unless");
      if (when != null) return v === when;
      if (unless != null) return v !== unless;
      return false;
    });
  }
  // Resolve the add-on variant + price, optionally by a thickness group (thick costs more).
  function resolveSurcharge(s) {
    var tg = s.getAttribute("data-surcharge-thickness-group");
    if (tg) {
      var g = root.querySelector('[data-group="' + tg + '"]');
      var thick = g && activeVal(g) === "Thick";
      return {
        vid: parseInt(s.getAttribute(thick ? "data-surcharge-vid-thick" : "data-surcharge-vid-thin"), 10),
        price: parseFloat(s.getAttribute(thick ? "data-surcharge-price-thick" : "data-surcharge-price-thin")) || 0
      };
    }
    return {
      vid: parseInt(s.getAttribute("data-surcharge-vid"), 10),
      price: parseFloat(s.getAttribute("data-surcharge-price")) || 0
    };
  }

  function applyConditionals() {
    texts.forEach(function (t) {
      var sg = t.getAttribute("data-show-group");
      var wrap = t.closest("[data-textwrap]") || t;
      if (!sg) { return; }
      var g = root.querySelector('[data-group="' + sg + '"]');
      var show = g && activeVal(g) === t.getAttribute("data-show-val");
      wrap.hidden = !show;
    });
  }

  groups().forEach(function (g) {
    g.querySelectorAll(".option__btn").forEach(function (b) {
      b.addEventListener("click", function () {
        g.querySelectorAll(".option__btn").forEach(function (x) { x.classList.toggle("is-selected", x === b); });
        applyConditionals();
        recompute();
      });
    });
  });
  texts.forEach(function (t) { t.addEventListener("input", recompute); });

  // recompute when the variant (size) changes — option buttons handled by theme.js
  form.querySelectorAll(".option__btn[data-opt-name]").forEach(function (b) {
    b.addEventListener("click", function () { setTimeout(recompute, 0); });
  });

  function currentVid() { var el = form.querySelector("[data-variant-id]"); return el ? el.value : null; }
  function sizeLabel() {
    var b = form.querySelector(".option__btn[data-opt-name].is-selected");
    return b ? b.getAttribute("data-opt-value") : null;
  }

  function collect() {
    var props = {};
    groups().forEach(function (g) {
      var name = g.getAttribute("data-group");
      var v = activeVal(g);
      if (v != null) props[name] = v;
    });
    texts.forEach(function (t) {
      var wrap = t.closest("[data-textwrap]") || t;
      if (!wrap.hidden && t.value.trim()) props[t.getAttribute("data-prop-text")] = t.value.trim();
    });
    return props;
  }

  function recompute() {
    var dl = root.querySelector("[data-summary]");
    if (!dl) return;
    var rows = [];
    var sz = sizeLabel();
    if (sz) rows.push(["Size", sz]);
    var props = collect();
    Object.keys(props).forEach(function (k) { rows.push([k, props[k]]); });
    activeSurcharges().forEach(function (s) {
      var rp = resolveSurcharge(s).price;
      if (rp > 0) rows.push([s.getAttribute("data-surcharge-label") || "Add-on", "+" + money(rp)]);
    });
    dl.innerHTML = rows.map(function (r) {
      return '<div class="summary__row"><dt>' + r[0] + "</dt><dd>" + (r[1] || "—") + "</dd></div>";
    }).join("");
  }

  function add() {
    var vid = currentVid();
    if (!vid) return;
    var items = [{ id: parseInt(vid, 10), quantity: 1, properties: collect() }];
    var forTitle = document.querySelector(".product__title");
    activeSurcharges().forEach(function (s) {
      var rs = resolveSurcharge(s);
      if (rs.vid && rs.price > 0) items.push({ id: rs.vid, quantity: 1, properties: { "Add-on for": forTitle ? forTitle.textContent.trim() : "" } });
    });
    var btns = document.querySelectorAll("[data-optadd]");
    btns.forEach(function (b) { b.disabled = true; });
    window.WCBuilderAdd(items).catch(function (e) { alert(e.message || "Unable to add"); })
      .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
  }
  document.querySelectorAll("[data-optadd]").forEach(function (b) { b.addEventListener("click", add); });

  applyConditionals();
  recompute();
})();
